import { RequestBuilder, authorizedPipe } from 'services/net'
import { CONTENT_SERVICE_URL } from 'config'
import { RangeFilter, LegacyPhoto } from 'interfaces'
import { StockContentProvider } from 'interfaces/Content/StockContentProvider'
import { SortBy, STOCK_CONTENT_PROVIDER_PARAMS_MAP } from '../util'

export const ENDPOINT_PHOTOS_EXTRACT = `${CONTENT_SERVICE_URL}/feeds/:sourceId/content/photos`
export const ENDPOINT_PHOTOS_FOLDER_EXTRACT = `${CONTENT_SERVICE_URL}/streams/:folderId/content/photos`

export const V1 = Object.freeze({

  getPhotos: function () {
    return function (
      sourceId: string,
      page: number,
      rangeFilter: RangeFilter,
      sortBy: SortBy,
      stockSource?: StockContentProvider
    ) {
      const builder = new RequestBuilder(ENDPOINT_PHOTOS_EXTRACT).asGet().expectJSON().withoutCredentials()
      if (stockSource) {
        builder.param('stock_filter', STOCK_CONTENT_PROVIDER_PARAMS_MAP.photos[stockSource])
      }

      return authorizedPipe<{ content: LegacyPhoto[] }>(
        builder
          .partial(':sourceId', sourceId)
          .param('page', page.toString())
          .param('range_filter', rangeFilter)
          .param('sort_by', sortBy)
          .build()
      )
    }
  }(),
  getPhotosFromFolder: function () {
    const builder = new RequestBuilder(ENDPOINT_PHOTOS_FOLDER_EXTRACT).asGet().expectJSON().withoutCredentials()

    return function (folderId: string, page: number, rangeFilter: RangeFilter, sortBy: SortBy) {
      return authorizedPipe<{ content: LegacyPhoto[] }>(
        builder
          .partial(':folderId', folderId)
          .param('page', page.toString())
          .param('range_filter', rangeFilter)
          .param('sort_by', sortBy)
          .build()
      )
    }
  }()
})
